import {
  CLOSE_SNACKBAR,
  FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS,
  FETCH_CREATE_TEMPLATE_SUCCESS,
  FETCH_CREATE_SCENE_SUCCESS,
  FETCH_CREATE_SLATE_SUCCESS,
  FETCH_CREATE_TAKE_SUCCESS,
  FETCH_DELETE_TEMPLATE_SUCCESS,
  FETCH_SAVE_TEMPLATE_SUCCESS,
  FETCH_SAVE_SCENE_SUCCESS,
  FETCH_SAVE_SLATE_SUCCESS,
  FETCH_SAVE_TAKE_SUCCESS,
  FETCH_DELETE_SCENE_SUCCESS,
  FETCH_DELETE_SLATE_SUCCESS,
  FETCH_DELETE_TAKE_SUCCESS,
} from '../constants/ActionTypes'

export default (state = {
  snackbar: {
    open: false,
    message: null
  }
}, {type, payload}) => {
  switch (type) {
    case FETCH_CREATE_TEMPLATE_SUCCESS:
    case FETCH_SAVE_TEMPLATE_SUCCESS:
    case FETCH_DELETE_TEMPLATE_SUCCESS:
    case FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS:
    case FETCH_CREATE_SCENE_SUCCESS:
    case FETCH_CREATE_SLATE_SUCCESS:
    case FETCH_CREATE_TAKE_SUCCESS:
    case FETCH_SAVE_SCENE_SUCCESS:
    case FETCH_SAVE_SLATE_SUCCESS:
    case FETCH_SAVE_TAKE_SUCCESS:
    case FETCH_DELETE_SCENE_SUCCESS:
    case FETCH_DELETE_SLATE_SUCCESS:
    case FETCH_DELETE_TAKE_SUCCESS:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open: true,
          message: payload.message
        }
      }

    case CLOSE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          open: false,
          message: null
        }
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./reducers/Notifications.js